import React from "react";
import { useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import MemberLayout from "@/components/MemberLayout";

// Public pages that verified members should see inside the member shell.
export default function AdaptiveLayout() {
  const { user } = useAuth();
  if (user === undefined) {
    return <div className="min-h-screen flex items-center justify-center text-[var(--hh-sage)] label-eyebrow">Loading…</div>;
  }
  const member = user && (user.role === "admin" || user.is_id_verified !== false);
  return member ? <MemberLayout /> : <Layout />;
}
